import type {PiralPlugin} from 'piral-core';

import {BFFOAuthClient, OAuthUser} from "@prowin/bff-oauth-client";

import {createActions} from "./actions";
import {getOAuthValue} from "./index";
import {PiletOAuthApi} from "./types";

export function createOAuthApi(config: { oauth: BFFOAuthClient }): PiralPlugin<PiletOAuthApi> {
    const {oauth} = config;

    return (context) => {
        context.defineActions(createActions(oauth));

        //This here is for GlobalState Use
        context.dispatch(state => ({
            ...state,
            oauth: getOAuthValue(oauth),
            bffOauth: oauth
        }));

        const _getBffOauthClient = (): BFFOAuthClient => {
            return oauth
        }

        const _doRefreshToken = (): Promise<object> => {
            return Promise.resolve({refreshToken: "", accessToken: "", data: {"expires_at": ""}, bearer: ""})
        }

        //From line 58, these are sent to pilets
        return () => {
            return {
                isUserAuthenticated(): boolean {
                    return oauth.initialized
                },

                doUserLogout(): void {
                    oauth.logout();
                },

                getOAuthToken(): object {
                    return {}
                },
                getUserData(): OAuthUser {
                    return oauth.user
                },
                getBffOauthClient(): BFFOAuthClient {
                    return _getBffOauthClient()
                },
                doRefreshToken(): Promise<object> {
                    return _doRefreshToken()
                },
                //TODO:Removed is token valid. Not helpful in pilets as value doesnt update
                isTokenValid: oauth.initialized
            }
        }
    }
}
